import React from 'react'
import { shape, string, node } from 'prop-types'
import { render } from 'react-dom'
import { withRouter } from 'react-router'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import 'moment/locale/id'
import store, { history } from './store'
import App from './containers/App'
import registerServiceWorker from './registerServiceWorker'

const target = document.querySelector('#root')

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}

ScrollToTop.propTypes = {
  location: shape({
    pathname: string.isRequired,
  }).isRequired,
  children: node.isRequired,
}

const WrappedScroll = withRouter(ScrollToTop)

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <WrappedScroll>
        <App />
      </WrappedScroll>
    </ConnectedRouter>
  </Provider>,
  target,
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js